import Force3 from './force3'

type V3 = [number, number, number]

export interface HookesOptions {
  k?: number
  d?: number
  m?: number
}

export default class Hookes {
  velocity: V3 = [0, 0, 0]
  acceleration: V3 = [0, 0, 0]
  anchor: V3 = [0, 0, 0]

  k: number
  d: number
  m: number

  constructor(opt: HookesOptions = {}) {
    this.k = opt.k !== undefined ? opt.k : 0.3
    this.d = opt.d !== undefined ? opt.d : 0.7
    this.m = opt.m !== undefined ? opt.m : 1
  }

  render(): void {
    Force3.applyHook(this.velocity, this.acceleration, this.anchor, 0, this.k)
    Force3.applyDrag(this.acceleration, this.d)
    Force3.updateVelocity(this.velocity, this.acceleration, this.m)
  }
}
